<template>
    <div>
        <v-dialog
            v-model="showWebshop"
            :persistent="true"
            max-width="700px"
            content-class="overflow-visible-dialog"
        >
            <v-card class="modal--tips4y">
                <v-card-title class="headline d-flex justify-center">
                    <h2 class="mb-0">
                        {{ $t("backoffice.modules-management.webshop.title") }}
                    </h2>
                    <div class="icon-close" @click="handleCloseTicket">
                        <div>
                            <img
                                src="/images/_SVGs/environmental/fechar.svg"
                                onload="SVGInject(this)"
                                width="20"
                                height="20"
                            />
                        </div>
                    </div>
                </v-card-title>

                <v-card-text>
                    <v-form v-model="validateForm" ref="datarepair_form">
                        <multiselect
                            v-model="selectedUser"
                            label="text"
                            track-by="value"
                            :placeholder="
                                $t('backoffice.general.users-capitalize')
                            "
                            open-direction="bottom"
                            :options="allUsers.data"
                            :searchable="true"
                            :loading="isLoading"
                            :internal-search="false"
                            :clear-on-select="true"
                            :close-on-select="true"
                            :max-height="600"
                            :show-no-results="false"
                            :hide-selected="true"
                            @search-change="asyncFind"
                        >
                            <template slot="afterList">
                                <div
                                    v-if="allUsers.hasMorePages"
                                    class="w-100 d-flex justify-content-center"
                                >
                                    <v-btn
                                        text
                                        class="danger-button w-80 text-muted"
                                        @click="loadMoreUsers"
                                    >
                                        <span
                                            style="text-transform: capitalize"
                                            >{{
                                                $t(
                                                    "backoffice.modules.estimate.load-more"
                                                )
                                            }}</span
                                        >
                                    </v-btn>
                                </div>
                            </template>
                        </multiselect>
                    </v-form>
                </v-card-text>

                <v-card-actions class="row-button justify-center">
                    <div class="ml-2">
                        <v-btn
                            class="primary-button"
                            text
                            :disabled="validadeBtnWebshop"
                            @click="handleGetWebshopUrl"
                            :loading="generatingUrl"
                        >
                            <span style="text-transform: capitalize">
                                {{
                                    $t("request-manager.edit-ticket.save-order")
                                }}
                            </span>
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <base-modal
            :persistent="true"
            v-model="modalInfo.show"
            :title="$t('alert')"
            modal-width="560px"
            iconColor="warning"
            iconName="mdi-alert-outline"
        >
            <template v-slot:modal-body>
                <div style="white-space: pre-line">
                    {{ modalInfo.message }}
                </div>
            </template>

            <template v-slot:modal-actions>
                <div></div>
                <div>
                    <v-btn
                        color=""
                        text
                        class="primary-button"
                        @click="closeInfoModal"
                    >
                        {{ $t("ok") }}
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
import {
    UserServicesGetWebshopUsers,
    UserServicesGetWebshopUrl,
} from "@services/UserServices";
import Multiselect from "vue-multiselect";
import _ from "lodash";

export default {
    components: { Multiselect },
    data() {
        return {
            validateForm: false,
            selectedUser: null,
            isLoading: false,
            generatingUrl: false,
            allUsers: {
                data: [],
                currentPage: 1,
                pageSize: 10,
                searchText: "",
            },
            modalInfo: {
                show: false,
                message: this.$t(
                    "backoffice.modules-management.webshop.no-content"
                ),
            },
        };
    },
    computed: {
        showWebshop() {
            return this.$store.getters["menuLinks/getWebshopState"];
        },
        validadeBtnWebshop() {
            return this.selectedUser == null;
        },
    },
    methods: {
        closeInfoModal() {
            this.modalInfo.show = false;
        },
        asyncFind: _.debounce(function (query) {
            this.isLoading = true;
            this.allUsers.currentPage = 1;
            this.allUsers.searchText = query;
            this.getUsersDropdowns(true);
        }, 300),
        mergeArraysOfObjects(arr1, arr2) {
            const merged = [...arr1, ...arr2];
            const uniqueMap = new Map();

            merged.forEach((obj) => {
                if (!uniqueMap.has(obj.value)) {
                    uniqueMap.set(obj.value, obj);
                }
            });

            return Array.from(uniqueMap.values());
        },
        async organizeUsersDrop(data, isSearch) {
            const newUsers = data.result.map((el) => ({
                text: el.name,
                value: +el.value,
            }));

            if (isSearch) {
                this.allUsers.data = newUsers;
            } else {
                this.allUsers.data = this.mergeArraysOfObjects(
                    this.allUsers.data,
                    newUsers
                );
            }

            this.allUsers.hasMorePages = data.currentPage < data.totalPages;
            this.isLoading = false;
        },
        async getUsersDropdowns(search = false, firstCall = false) {
            const tableFilters = {
                searchText: this.allUsers.searchText,
                pageSize: this.allUsers.pageSize,
                currentPage: this.allUsers.currentPage,
            };

            UserServicesGetWebshopUsers(tableFilters)
                .then((response) => {
                    if (response.data) {
                        if (firstCall) {
                            this.selectedUser = response.data.result
                                .map((el) => ({
                                    text: el.name,
                                    value: +el.value,
                                    isSelected: el.isSelected,
                                }))
                                .find((o) => o.isSelected);
                        }
                        this.organizeUsersDrop(response.data, search);
                    }
                })
                .catch((error) => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    throw new Error("error to get users dropdown", error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        loadMoreUsers() {
            if (this.allUsers.hasMorePages) {
                this.isLoading = true;
                this.allUsers.currentPage++;
                this.getUsersDropdowns();
            }
        },
        handleGetWebshopUrl() {
            if (!this.selectedUser) return;
            this.generatingUrl = true;

            UserServicesGetWebshopUrl(this.selectedUser.value)
                .then((response) => {
                    if (
                        response.status == this.$globals.ERROR_CODES.NO_CONTENT
                    ) {
                        this.modalInfo.show = true;
                        this.handleCloseTicket();
                    }
                    if (response.data.result) {
                        window.open(response.data.result);
                    }
                })
                .catch((error) => {
                    console.error("Error getting webshop URL:", error);
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                })
                .finally(() => {
                    this.generatingUrl = false;
                });
        },
        async handleCloseTicket() {
            this.$store.commit("menuLinks/setWebshopState", false);
            this.selectedUser = null;
            this.allUsers.currentPage = 1;
            this.allUsers.searchText = "";
        },
    },
    watch: {
        showWebshop: {
            handler: function (newValue, oldValue) {
                if (newValue) {
                    this.getUsersDropdowns(false, true);
                }
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>

<style lang="scss">
.overflow-visible-dialog {
    overflow: visible !important;

    .v-card {
        overflow: visible !important;
    }
}

.multiselect {
    min-height: 57px;
    border: 1px solid #949494;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-top-right-radius: 4px !important;
    border-top-width: 0;
    border-right-width: 0;
    border-left-width: 0;
}

.multiselect__tags {
    min-height: 57px !important;
    background: rgba(0, 0, 0, 0.06) !important;
}

.multiselect__input {
    background: rgba(0, 0, 0, 0.06) !important;
}

.multiselect__option--highlight {
    background: #f6f6f6 !important;
    color: #000 !important;
}

.multiselect__option--selected.multiselect__option--highlight {
    background: #f6f6f6 !important;
    color: #000 !important;
}

.multiselect__option--highlight::after {
    background: #f6f6f6 !important;
    color: #000 !important;
}

.multiselect__option:hover {
    color: #000 !important;
}

.multiselect__option--selected::after {
    background: #f6f6f6 !important;
    color: #000 !important;
}

.multiselect__content {
    padding-left: 0 !important;
}
</style>
